import { gql } from "graphql-tag";
import React from "react";
import { useMutation } from "@apollo/client";
import { authorizeForRole } from "components/auth/authorize-for-role";
import { createProperty as createPropertyType, createPropertyVariables, UserRole } from "types/gql-types";
import { AdminHeading } from "../shared/admin-form";
import { useAdminSubmit } from "../shared/use-admin-submit";
import PropertyForm, { Property } from "./form";

const CREATE_PROPERTY = gql`
  mutation createProperty($data: PropertyCreateInput!) {
    createProperty(data: $data) {
      name
      phone
      phoneExt
      email
      interestListId
      address {
        address1
        city
        state
        zip
      }
      submissionDigestEnabled
    }
  }
`;

const initialData = {
  organizationId: "",
  name: "",
  phone: "",
  phoneExt: "",
  email: "",
  interestListId: "",
  address: {
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
  },
  submissionDigestEnabled: true,
  units: null as number | null,
};

const NewProperty: React.FC = () => {
  const { sending, submit } = useAdminSubmit("/dash/admin/properties");
  const [createProperty] =
    useMutation<createPropertyType, createPropertyVariables>(CREATE_PROPERTY);
  const submitForm = (formData: Property) =>
    submit(() => createProperty({ variables: { data: formData } }));
  return (<div>
    <AdminHeading>Create a property</AdminHeading>
    <PropertyForm
      formType="new"
      initialData={initialData}
      sending={sending}
      handleSubmit={submitForm}
    />
  </div>);
};

export default authorizeForRole([UserRole.ADMIN], NewProperty);
